import React from 'react';
import { bonuses } from '../data/content';
import { BONUS_SIZES, BONUS_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/images';
import { Accent, SectionHeading } from './SectionHeading';
export function BonusesSection() {
  return <section className="w-full bg-cream-100 px-6 pb-14 pt-4 sm:pb-16" aria-labelledby="bonos-titulo" data-id="element-1" data-mp="vu7fu9ido78e">
      <div className="mx-auto max-w-4xl" data-id="element-2" data-mp="qsi40rnbzpj9">
        <SectionHeading id="bonos-titulo" title={<>
              6 Bonos Estratégicos <Accent data-id="element-4" data-mp="zv9hewzrovdj">Siempre Incluidos</Accent>
            </>} subtitle="Implementación docente al 100%: planes de clase, plantillas imprimibles, ejercicios, laboratorios low-cost y evaluación profesional." data-id="element-3" data-mp="14tawl6u2oajq" />

        <ul className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-5" data-mp="19kt0o3re6r8x">
          {bonuses.map(({
          number,
          title,
          description,
          image
        }) => <li key={number} className="flex h-full flex-col overflow-hidden rounded-2xl border border-cream-300/70 bg-cream-50 p-4" data-id="element-6" data-mp="1jiqo4p1fgk0h">
              <div className="relative overflow-hidden rounded-xl bg-cream-100 py-3" data-id="element-7" data-mp="3pseswnfh64j1">
                <img src={optimizedImage(image, 420)} srcSet={optimizedSrcSet(image, BONUS_WIDTHS)} sizes={BONUS_SIZES} alt={`Portada del bono ${number}: ${title}`} width={1070} height={1456} loading="lazy" decoding="async" className="mx-auto aspect-[3/4] w-2/3 object-contain" data-id="element-8" data-mp="3ts712z0yi8nv" />
                <span className="absolute right-3 top-3 rounded-md bg-forest-700 px-2.5 py-1 text-[0.65rem] font-bold uppercase tracking-wider text-ember-400" data-id="element-9" data-mp="lbu3t6spoeud">
                  Gratis
                </span>
              </div>
              <h3 className="mt-4 font-display text-lg font-semibold leading-snug text-forest-800" data-id="element-10" data-mp="vbuoox68b30o">
                {title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-forest-700/85" data-id="element-11" data-mp="al8pd54cm9hh">{description}</p>
            </li>)}

          <li className="flex h-full flex-col items-center justify-center rounded-2xl bg-forest-700 p-8 text-center sm:col-span-2 lg:col-span-3" data-id="element-12" data-mp="5mxd6nqkzmw3">
            <p className="font-display text-2xl font-semibold leading-snug text-cream-50" data-id="element-13" data-mp="kcd4q5xxrwcu">
              Valor total de bonos <span className="text-[28px] text-ember-400" data-id="element-14" data-mp="fih7x6tesfj9">$90 USD</span>
            </p>
            <p className="mt-3 text-sm text-cream-100/75" data-id="element-15" data-mp="tdtcs71a3mdw">GRATIS con tu Mega Kit.</p>
          </li>
        </ul>
      </div>
    </section>;
}